module.exports = __webpack_public_path__ + "img/photo_2023-11-19 17.44.04.8103e6a8.jpg";